import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { APIS } from 'src/lib/constants/apis';
import { FormStrucItem } from 'src/lib/types/types';
import { enumT } from 'src/utils/helper';

// import schemas
import HochschuleSchema from 'src/lib/paths/hochschule_FULL_Paths.json';
const P = HochschuleSchema.attributes;

const NeueHochschuleDaten: FC<{
	formValues: any;
	updateFormValuesFunc: (_key: string, _value: any) => void;
	formErrors?: any;
}> = ({ formValues, updateFormValuesFunc, formErrors }) => {
	return (
		<CreateForm
			formStruc={formStruc()}
			formValues={formValues}
			updateFormValuesFunc={updateFormValuesFunc}
			formErrors={formErrors}
			api={APIS.Hochschule}
		/>
	);
};

export default NeueHochschuleDaten;

const formStruc = () => {
	const landkeitsoptionen = [
		...P.Adressdaten_Landkreis_Kreisfreie_Stadt.enum
			.filter((option) => option !== 'NichtInHessen')
			.sort((a, b) => enumT(a).localeCompare(enumT(b), 'de'))
			.map((option) => ({
				label: enumT(option),
				value: option,
			})),

		{ value: 'NichtInHessen', label: `<em>--- Nicht in Hessen ---</em>` },
	];

	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Geschaeftsbezogene_Daten_Name_Der_Organisation,
					label: 'Rechtsverbindlicher Name der Hochschule / Forschungseinrichtung',
					fieldGroupWidth: '70%',
				},
				{ ...P.Geschaeftsbezogene_Daten_Kuerzel, fieldGroupWidth: '30%' },
			],
		},
		{
			fields: [{ ...P.Geschaeftsbezogene_Daten_Rechtsform_Der_Organisation }],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
		{
			fields: [{ ...P.Unternehmensprofil_Steuernummer }, { ...P.Unternehmensprofil_U_St_Id_Nr }],
		},
		{
			fields: [{ ...P.Adressdaten_Strasse_Und_Hausnummer }],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
		{
			fields: [{ ...P.Adressdaten_Adresszusatz }],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
		{
			fields: [{ ...P.Adressdaten_PLZ }, { ...P.Adressdaten_Ort }],
			userProps: { columnToDivide: 2, columnGap: '1rem' },
		},
		{
			fields: [{ ...P.Adressdaten_Landkreis_Kreisfreie_Stadt, options: landkeitsoptionen, sortAlphabetically: false }],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
		{
			fields: [
				{ ...P.Kontaktdaten_E_Mail, label: 'E-Mail (Organisation)' },
				{ ...P.Kontaktdaten_Telefon, label: 'Telefon (Organisation)' },
			],
			userProps: { columnToDivide: 2, columnGap: '1rem' },
		},
	];
	return struc;
};
